import {dwhFuntoneChangeDefaultSong, dwhFuntoneChangeDefaultSongSuccess, dwhFuntoneChangeDefaultSongFailed} from '../../../Reports/dwhReports';
import {getCommonReportParams} from '../../../Reports/reportHelpers';

/**
 * Handler for submitting default song selection
 */
export const createHandleSubmitDefaultSong = ({
  selectedSongId,
  selectedSubscriber,
  subscriberGallery,
  dispatch,
  showToast,
  setDefaultSong,
  getSubscribersData,
  setIsChangeDefaultSongFlow,
  setCurrentScreen,
  ScreensEnum,
  loginData,
}) => {
  return async () => {
    if (!selectedSongId) {
      dispatch(showToast('נא לבחור שיר'));
      return;
    }

    const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;

    if (!cli) {
      dispatch(showToast('שגיאה: לא נבחר מנוי'));
      return;
    }

    // Find the current default song
    const currentDefaultSong = subscriberGallery.find((song) => song.isDefault === true);
    const currentDefaultSongId = currentDefaultSong?.productId || currentDefaultSong?.id;

    // If the selected song is the same as the current default, just navigate back without API call
    if (selectedSongId == currentDefaultSongId) {
      dispatch(setIsChangeDefaultSongFlow(false));
      setCurrentScreen(ScreensEnum.ADMIN_PANEL);
      return;
    }

    // Report change default song initiated
    const reportParams = getCommonReportParams(selectedSubscriber, loginData);
    dwhFuntoneChangeDefaultSong({
      ...reportParams,
      ban: loginData?.userDetails?.ban || '',
      crmId: loginData?.userDetails?.crmId || '',
    });

    const action = await dispatch(
      setDefaultSong({
        subscriber: cli,
        productId: selectedSongId,
      }),
    );

    if (action.type.endsWith('/fulfilled')) {
      // Report change default song success
      dwhFuntoneChangeDefaultSongSuccess({
        ...reportParams,
        ban: loginData?.userDetails?.ban || '',
        crmId: loginData?.userDetails?.crmId || '',
      });
      dispatch(showToast('השיר הקבוע הוגדר בהצלחה'));
      // Refresh subscribers data to get updated default song info (gallery is already refreshed by the thunk)
      dispatch(setIsChangeDefaultSongFlow(false));
      setCurrentScreen(ScreensEnum.ADMIN_PANEL);
    } else {
      // Report change default song failure
      dwhFuntoneChangeDefaultSongFailed({
        ...reportParams,
        ban: loginData?.userDetails?.ban || '',
        crmId: loginData?.userDetails?.crmId || '',
      });
      dispatch(showToast('יש להוריד שיר לפני החלפת שיר קבוע'));
    }
  };
};
